/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import {
    ApiError400DefaultCodeEnum,
    ApiError500DefaultCodeEnum,
    ErrorCode,
} from 'client-code/actions';
import { ErrorTypes } from './ErrorTypes';
import { AppError } from './AppError';
import { Locale } from '../locale/Locale';
import { LocaleKeys } from '../locale/LocaleKeys';

export class OfferActionError extends AppError {
    TAG: string = 'OfferActionError';

    protected title: string = Locale.getString(LocaleKeys.SOCU_ERROR_OVERLAY_TITLE);

    protected type: string;

    constructor(message: string, code: string, description: string) {
        super(code, message);
        this.description = description;
        this.message = message;
        this.type = code;
        this.setCode(code);
    }

    private setCode(code: string): void {
        switch (code) {
            case ErrorCode.Apigw401:
            case ErrorCode.Apigw4Xx:
            case ErrorCode.Apigw5Xx:
            case ApiError400DefaultCodeEnum.ApigwError:
            case ApiError500DefaultCodeEnum.ApigwError:
                this.code = ErrorTypes.OFFER_ACTION_APIGW_ERROR_V201;
                break;
            case ErrorCode.BadRequest:
            case ApiError400DefaultCodeEnum.BadRequest:
                this.code = ErrorTypes.OFFER_ACTION_BAD_REQUEST_ERROR_V202;
                break;
            case ApiError500DefaultCodeEnum.InternalServerError:
                this.code = ErrorTypes.OFFER_ACTION_INTERNAL_SERVER_ERROR_V204;
                break;
            case ErrorCode.UnexpectedError:
                this.code = ErrorTypes.OFFER_ACTION_UNEXPECTED_ERROR_V205;
                break;
            default:
                this.code = ErrorTypes.OFFER_ACTION_UNKNOWN_ERROR_V299;
                this.type = 'OFFER_ACTION_UNKNOWN_ERROR';
        }
    }

    public getTitle(): string {
        return this.title;
    }

    public getType(): string {
        return this.type;
    }
}
